export const FETCH_CODE_REFS_BEGIN = "FETCH_CODE_REFS_BEGIN";
export const FETCH_CODE_REFS_SUCCESS = "FETCH_CODE_REFS_BEGIN";
export const FETCH_CODE_REFS_FAILURE = "FETCH_CODE_REFS_FAILURE";
export const DELETE_COMMENT_IMAGE_BEGIN = "DELETE_COMMENT_IMAGE_BEGIN";
export const DELETE_COMMENT_IMAGE_SUCCESS = "DELETE_COMMENT_IMAGE_SUCCESS";
export const DELETE_COMMENT_IMAGE_FAILURE = "DELETE_COMMENT_IMAGE_FAILURE";
export const ADD_COMMENT_IMAGE_BEGIN = "ADD_COMMENT_IMAGE_BEGIN";
export const ADD_COMMENT_IMAGE_SUCCESS = "ADD_COMMENT_IMAGE_SUCCESS";
export const ADD_COMMENT_IMAGE_FAILURE = "ADD_COMMENT_IMAGE_FAILURE";
export const FETCH_COMMENT_FAILURE = "FETCH_COMMENT_FAILURE";
export const FETCH_COMMENT_BEGIN = "FETCH_COMMENT_BEGIN";
export const FETCH_COMMENT_SUCCESS = "FETCH_COMMENT_SUCCESS";
export const UPDATE_COMMENT_BEGIN = "UPDATE_COMMENT_BEGIN";
export const UPDATE_COMMENT_SUCCESS = "UPDATE_COMMENT_SUCCESS";
export const UPDATE_COMMENT_FAILURE = "UPDATE_COMMENT_FAILURE";
